import { useState } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router'
import { AppProviders, createQueryClient } from './app/AppProviders'
import { routes } from './app/routes'

const router = createBrowserRouter(routes)

export function App() {
  const [queryClient] = useState(createQueryClient)
  return (
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  )
}
